import FormTextField from "../../../../components/UI/FormTextField";

export default function ShareMessageField(props) {
  const { classes, control } = props;

  return (
    <div className={classes.formControl} data-testid="share-message-field-container">
      <FormTextField
        name="message"
        label="Enter message here"
        variant="standard"
        control={control}
        fullWidth
        classes={{ root: classes.textField }}
        inputProps={{
          fullWidth: true,
        }}
      />
    </div>
  );
}
